import React from 'react';
import { useState } from "react";
import {
    Typography,
    Grid,
} from '@mui/material';
import { useHistory } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import InputMask from 'react-input-mask';

const AdjusterInfoEntry = (props) => {
    // ** States   
    const [hasResult, setHasResult] = useState(false);
    const [error, setError] = useState(null);
    const [createUser, setCreateUser] = useState(false);
    const [data, setData] = useState(null);
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const { phoneNumber, noSearchFound } = props?.location?.state?.data?.users?.$values[0] ?? props?.location?.state.data ?? {};
    // localStorage.setItem('defaultEventId', 1); //Remove later

    const handleCloseProgressBar = () => {
        setOpenProgressBar(false);
    };
    const history = useHistory();

    const handleCreateUser = () => {
        const firstName = document.querySelector('input[placeholder="Enter First Name"]').value;
        const lastName = document.querySelector('input[placeholder="Enter Last Name"]').value;
        const email = document.querySelector('input[placeholder="Enter Email"]').value;
        let phoneNumber = document.querySelector('input[placeholder="Enter Phone Number"]').value;
        phoneNumber = phoneNumber.replace(/\D/g, '');

        const params = {
            firstName,
            phoneNumber,
            lastName,
            email
        };

        if (firstName && lastName && phoneNumber && email) {
            handleAddUser(params);
        } else {
            setError("Please fill in all fields.");
        }
    };

    const handleAddUser = (params) => {
        setHasResult(false);
        setOpenProgressBar(true);
        setError(null);

        fetch(`/api/Adjuster/PostNewTempUser`, {
            method: 'POST',
            body: JSON.stringify({
                "FirstName": params.firstName,
                "LastName": params.lastName,
                "PhoneNumber": params.phoneNumber,
                "Email": params.email,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then((data) => {
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                    setData({ ...params, userId: data.tempUserId, count: -1 });
                    history.push({ pathname: '/Verification', state: { data: { ...params, userId: data.tempUserId, count: -1 } } });
                }
                else {
                    setError("No results found");
                    setCreateUser(true);
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                if (error.message.includes("No user")) {
                    setError("No user found with adjuster Id: " + params.pilotId);
                }
                else {
                    setError("An error occurred, please try again later");
                }
                setOpenProgressBar(false);
            });
    }

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    return (
        <>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={11} md={11}>
                    <div className="bg-white rounded-lg p-8 space-y-4 flex flex-col shadow-2xl">
                        <div className="bg-white max-w-xl mx-auto">
                            <div className="text-center max-w-md mx-auto space-y-4 p-4">
                                <h2 className="text-xl font-bold">PLEASE CREATE A USER</h2>
                            </div>                         
                            <div className="flex flex-col">
                                <div className="flex flex-row justify-between mb-4">
                                    <div className="mr-4">
                                        <label htmlFor="firstName" className="block text-gray-700 mb-2">First Name: <span className="text-red-500">*</span></label>
                                        <input type="text" id="firstName" placeholder="Enter First Name" className="border border-gray-300 rounded p-2 w-48" />
                                    </div>
                                    <div>
                                        <label htmlFor="lastName" className="block text-gray-700 mb-2">Last Name: <span className="text-red-500">*</span></label>
                                        <input type="text" id="lastName" placeholder="Enter Last Name" className="border border-gray-300 rounded p-2 w-48" />
                                    </div>
                                </div>
                                <div className="flex flex-row justify-between mb-4">
                                    <div>
                                        <label htmlFor="email" className="block text-gray-700 mb-2">Email: <span className="text-red-500">*</span></label>
                                        <input type="text" id="email" placeholder="Enter Email" className="border border-gray-300 rounded p-2 relative w-full min-w-[400px]" />
                                    </div>
                                </div>
                                <div className="flex flex-row justify-between mb-4">
                                    <div className="mr-4">
                                        <label htmlFor="cellPhone" className="block text-gray-700 mb-2">Phone Number: <span className="text-red-500">*</span></label>
                                        <InputMask
                                            mask="(999)-999-9999"
                                            maskChar=""
                                            id="cellPhone"
                                            defaultValue={phoneNumber}
                                            placeholder="Enter Phone Number"
                                            className="border border-gray-300 rounded p-2 w-48"
                                            inputMode="numeric"
                                            onChange={(e) => setError(null)} // Clear error on input change
                                        />
                                    </div>
                                </div>                               
                            </div>
                        </div>
                        <div className="flex justify-center">
                            <button className="bg-red-900 text-white rounded-full px-16 py-2 mb-2 sm:mb-0" onClick={() => {
                                const email = document.getElementById('email').value;
                                const cellPhone = document.getElementById('cellPhone').value.replace(/\D/g, '');
                                if (!validateEmail(email)) {
                                    setError("Please enter a valid email address.");
                                } else if (cellPhone.length !== 10 || isNaN(cellPhone)) {
                                    setError("Please enter a valid 10-digit phone number.");
                                } else {
                                    handleCreateUser();
                                }
                            }}>{phoneNumber ? 'Proceed and Create New User' : 'Create User' }</button>
                        </div>
                        <div className="flex justify-center">
                            {error && <div className="text-red-500">{error}</div>}
                        </div>
                    </div>                    
                </Grid>
            </Grid >
            <Backdrop
                open={openProgressBar}
                onClick={handleCloseProgressBar}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
};

export default AdjusterInfoEntry;